import { agencyApis } from '@apis/dashboard/agencyApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useAgency = createUseQuery(
  (id: number) => ['/dashboard/agency/', id],
  (id) => () => agencyApis.get('/dashboard/agency/{id}/', { path: { id } }).then((r) => r[200]!),
);
